import _extends from "@babel/runtime/helpers/esm/extends";
// Classes
import Metrics from "./Metrics.js"; // Types
// Constants
export const GAUGE_TYPE = 'metrics.gauge';
export const GAUGE_VERSION = '1.0.0';
/**
 * A gauge is a metric that represents a single numerical value that can arbitrarily go up and down.
 * It defines the value of a state.
 * See https://deezer.jira.com/l/c/1Y101sJ2 for more information.
 */
export default class GaugeMetrics extends Metrics {
  constructor(options) {
    var _options$value;
    super(options);
    this.value = void 0;
    this.value = (_options$value = options.value) != null ? _options$value : 0;
  }
  reset() {
    this.value = 0;
  }
  serialize() {
    return _extends({}, super.serialize(), {
      gauge: this.value
    });
  }
}
//# sourceMappingURL=GaugeMetrics.js.map